import styled from 'styled-components';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var ReasonList = styled.ul.withConfig({
  displayName: "submission-ban-reasonscomponent__ReasonList",
  componentId: "sc-9ehmld-0"
})(["margin:6px 0 12px;padding-inline-start:22px;list-style-type:disc;overflow-wrap:anywhere;white-space:pre-wrap;li + li{margin-top:4px;}"]);
export var SubmissionBanReasons = function SubmissionBanReasons(_ref) {
  var label = _ref.label,
      reason = _ref.reason,
      _ref$details = _ref.details,
      details = _ref$details === void 0 ? [] : _ref$details,
      fallbackReason = _ref.fallbackReason;
  var displayedReason = (reason === null || reason === void 0 ? void 0 : reason.trim()) || (details.length ? undefined : fallbackReason);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("strong", {
      children: [label, ":"]
    }), /*#__PURE__*/_jsxs(ReasonList, {
      children: [displayedReason && /*#__PURE__*/_jsx("li", {
        children: displayedReason
      }), details.map(function (_ref2, index) {
        var label = _ref2.label,
            value = _ref2.value;
        return /*#__PURE__*/_jsxs("li", {
          children: [label, ": ", /*#__PURE__*/_jsx("strong", {
            children: value
          })]
        }, index);
      })]
    })]
  });
};